import { render, staticRenderFns } from "./CommentsHistory.vue?vue&type=template&id=7944558e"
import script from "./CommentsHistory.vue?vue&type=script&lang=js"
export * from "./CommentsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports